import { z } from 'zod';
import { usersAddSchema } from '../create/createUserForm.schema';

export const editUserSchema = usersAddSchema.pick({
  name: true,
  surname: true,
  role: true,
  groupId: true,
});

export type EditUserValues = z.infer<typeof editUserSchema>;
